import { useCallback, useEffect } from 'react';

// @ts-expect-error - useCustomerActions is not typed yet
import { useCustomerActions } from 'src/store/customer';

const CUSTOMER_POOLING_INTERVAL = 5 * 60 * 1000; // 5 min

export const useMaintainCustomer = () => {
  const customerActions = useCustomerActions();

  // Update customer data each `CUSTOMER_POOLING_INTERVAL`
  const refreshCustomer = useCallback(() => {
    if (!customerActions.getCurrentCustomer()) {
      return;
    }
    customerActions.refreshCurrentCustomer();
  }, [customerActions]);

  useEffect(() => {
    refreshCustomer();

    const interval = setInterval(refreshCustomer, CUSTOMER_POOLING_INTERVAL);
    return () => clearInterval(interval);
  }, [refreshCustomer]);

  return refreshCustomer;
};
